import React, { useState, useEffect } from "react";
import { Nav, Avatar, Dropdown, Toast, Modal } from '@douyinfe/semi-ui';
import { IconInherit, IconBox, IconLink, IconCheckList, IconFile, IconGift, IconComment, IconUserCircle, IconQrCode, IconMember, IconBookStroked, IconVideo, IconIdCard, IconMapPin, IconImage, IconFlag, IconPriceTag, IconHome, IconUserSetting, IconUser, IconSetting, IconAppCenter, IconSafe, IconEdit, IconUserGroup, IconList, IconSemiLogo, IconHelpCircle, IconAscend, IconCopyAdd, IconHistory, IconMinimize, IconMenu, IconQuit, IconSync, IconChevronLeft, IconChevronRight, IconCode, IconCart, IconShoppingBag, IconCreditCard, IconPhoneStroke, IconServer, IconArticle, IconHistogram, IconDesktop, IconUserCardVideo, IconApartment, IconGridView, IconSourceControl } from '@douyinfe/semi-icons';

import styles from './MainLayout.module.scss';
import { siteConfig } from '../config';
import request from '../utils/request';
const defaultMenuData = [
    {
        key: '主页',
        text: '主页',
        icon: <IconHome />,
        children: [
            { key: 'Dashboard', text: '仪表盘', icon: <IconHome /> },
            { key: 'Profile', text: '账号信息', icon: <IconUserSetting /> },
            { key: 'Users', text: '用户管理', icon: <IconUser /> },
        ]
    },
    {
        key: '录播课程',
        text: '录播课程',
        icon: <IconVideo />,
        children: [
            { key: 'Teachers', text: '讲师管理', icon: <IconUser /> },
            { key: 'Lessons', text: '课程管理', icon: <IconVideo /> },
            { key: 'LessonSubjects', text: '专栏管理', icon: <IconBookStroked /> },
            { key: 'Lessonorders', text: '课程订单', icon: <IconCreditCard /> }
        ]
    },
    {
        key: '付费进群',
        text: '付费进群',
        icon: <IconUserGroup />,
        children: [
            { key: 'Joingroup', text: '付费进群', icon: <IconUserGroup /> },
            { key: 'Orderlist', text: '进群订单', icon: <IconList /> },
            { key: 'Distribution', text: '用户分销', icon: <IconAscend /> }
        ]
    },
    {
        key: '电子合同',
        text: '电子合同',
        icon: <IconBookStroked />,
        children: [
            { key: 'Fddtpls', text: '合同模板', icon: <IconBookStroked /> },
            { key: 'Fddtasks', text: '签署任务', icon: <IconBookStroked /> },
        ]
    },
    {
        key: '功能管理',
        text: '功能管理',
        icon: <IconAppCenter />,
        children: [
            { key: 'Weixinpublic', text: '小程序', icon: <IconCode /> },
            { key: 'Domainbind', text: '域名管理', icon: <IconSafe /> },
            { key: 'Slides', text: '轮播图管理', icon: <IconImage /> },
            { key: 'Articles', text: '文案管理', icon: <IconArticle /> },
            { key: 'Pages', text: '页面管理', icon: <IconPhoneStroke /> },
            { key: 'Channels', text: '渠道管理', icon: <IconUserGroup /> },
            { key: 'Allcategories', text: '分类管理', icon: <IconPriceTag /> },
            { key: 'SpFiles', text: '素材管理', icon: <IconImage /> },
            { key: 'Specialpages', text: '小程序页面', icon: <IconPhoneStroke /> },
            { key: 'Specialposters', text: '海报管理', icon: <IconImage /> },
            { key: 'Xcxtheme', text: '小程序主题', icon: <IconPhoneStroke /> },
            { key: 'Hotspoteditor', text: '热区编辑器', icon: <IconEdit /> },
            { key: 'Postereditor', text: '海报编辑器', icon: <IconImage /> },
            { key: 'SectionTpleditor', text: '模块编辑器', icon: <IconGridView /> },
            { key: 'Templates', text: '模板管理', icon: <IconCopyAdd /> },
            { key: 'QrCodeGenerator', text: '小程序码', icon: <IconQrCode /> },
            { key: 'XcxVersionManager', text: '小程序版本', icon: <IconSourceControl /> },
            { key: 'XcxDataCube', text: '数据分析', icon: <IconHistogram /> },
            { key: 'XcxDataScreen', text: '数据大屏', icon: <IconDesktop /> },
            { key: 'Allfields', text: '字段管理', icon: <IconList /> },
            { key: 'AllFieldVals', text: '字段值管理', icon: <IconList /> },
        ]
    },
    {
        key: '客户档案',
        text: '客户档案',
        icon: <IconUser />,
        children: [
            { key: 'AllFieldValObjs', text: '客户资料', icon: <IconList /> },
            { key: 'AllFieldValObjs?typ=20', text: '家政员资料', icon: <IconUserGroup /> },
        ]
    },
    {
        key: '店铺',
        text: '店铺',
        icon: <IconShoppingBag />,
        children: [
            { key: 'Categories', text: '商品分类', icon: <IconPriceTag /> },
            { key: 'Products', text: '商品管理', icon: <IconCart /> },
            { key: 'Products?with_tags=4096', text: '家政服务', icon: <IconApartment /> },
            { key: 'Orders', text: '订单管理', icon: <IconList /> },
            { key: 'Coupons', text: '优惠券', icon: <IconCreditCard /> },
            { key: 'Comments', text: '评论管理', icon: <IconEdit /> },
            { key: 'Stores', text: '门店管理', icon: <IconMapPin /> },
            { key: 'Vipcards', text: '会员卡管理', icon: <IconIdCard /> },
            { key: 'Uservipcard', text: '开卡管理', icon: <IconMember /> },
            { key: 'Fees', text: '费用管理', icon: <IconServer /> },
        ]
    },
    {
        key: '活动表单',
        text: '活动表单',
        icon: <IconFlag />,
        children: [
            { key: 'Form', text: '表单管理', icon: <IconList /> },
            { key: 'Meetings', text: '会议管理', icon: <IconUserCardVideo /> },
            { key: 'UserContracts', text: '合同管理', icon: <IconBookStroked /> },
            { key: 'UserVerify', text: '信用管理', icon: <IconSafe /> },
        ]
    },
    {
        key: '系统',
        text: '系统',
        icon: <IconSetting />,
        children: [
            { key: 'Subaccounts', text: '子账号管理', icon: <IconUserSetting /> },
            { key: 'UserAdmin', text: '用户管理员', icon: <IconUserSetting /> },
            { key: 'Oplog', text: '操作日志', icon: <IconList /> },
            { key: 'AccountAssets', text: '账号资产', icon: <IconCreditCard /> },
            { key: 'Settings', text: '系统设置', icon: <IconSetting /> }
        ]
    },

];

const MainLayout = ({ children, selectedKey, onSelect }) => {
    const [userInfo, setUserInfo] = useState(null);
    const [isCollapsed, setIsCollapsed] = useState(() => {
        const savedState = localStorage.getItem('navCollapsed');
        return savedState ? JSON.parse(savedState) : false;
    });
    const [isSecondaryNavCollapsed, setIsSecondaryNavCollapsed] = useState(() => {
        const savedState = localStorage.getItem('secondaryNavCollapsed');
        return savedState ? JSON.parse(savedState) : false;
    });
    const [menuData, setMenuData] = useState([]);
    const [currentFirstNav, setCurrentFirstNav] = useState(() => {
        // 则从URL路径获取
        const pathname = window.location.pathname;
        const currentPage = pathname.split('/').pop();
        // 遍历菜单数据查找当前页面所属的一级菜单
        for (const menu of defaultMenuData) {
            if (menu.children?.some(child => child.key.toLowerCase() === currentPage.toLowerCase())) {
                return menu.key;
            }
        }
        return '主页';
    });
    // 初始化selectedKey，如果没有传入则从URL获取
    const [currentSelectedKey, setCurrentSelectedKey] = useState(() => {
        if (selectedKey) return selectedKey;
        const pathname = window.location.pathname;
        const currentPage = pathname.split('/').pop() || 'Dashboard';
        // 确保当前页面在二级菜单中存在
        const currentMenu = defaultMenuData.find(menu => menu.children?.some(child => child.key.toLowerCase() === currentPage.toLowerCase()));
        console.log(currentMenu, currentMenu, defaultMenuData)
        if (currentMenu) {
            return currentPage;
        }
        // 如果当前页面不在二级菜单中，返回当前一级菜单的第一个子项
        const firstMenu = defaultMenuData.find(menu => menu.key === currentFirstNav);
        return firstMenu?.children?.[0]?.key || 'Dashboard';
    });

    // 当selectedKey prop变化时更新内部状态
    useEffect(() => {
        if (selectedKey) {
            setCurrentSelectedKey(selectedKey);
        }
    }, [selectedKey]);

    // 当一级菜单变化时，不再自动选中第一个子菜单项
    useEffect(() => {
    }, [currentFirstNav, menuData, currentSelectedKey]);

    // 当菜单状态改变时，保存到localStorage
    React.useEffect(() => {
        localStorage.setItem('currentFirstNav', currentFirstNav);
    }, [currentFirstNav]);
    const [currentFirstNavText, setCurrentFirstNavText] = useState('主页');

    const fetchUserInfo = async () => {
        try {
            const response = await request.get('/go/spc/me/');
            if (response.errno === 0 && response.sp) {
                setUserInfo(response.sp);
                localStorage.setItem('userInfo', JSON.stringify(response.sp));
            }
        } catch (error) {
            console.error('获取用户信息失败:', error);
        }
    };

    useEffect(() => {
        fetchUserInfo();
    }, []);

    // 图标组件映射对象
    const iconMap = {
        IconUserCircle, IconApartment, IconComment, IconGift, IconUserCardVideo, IconFlag,
        IconFile, IconCheckList, IconBox, IconLink, IconHistogram, IconQrCode, IconInherit,
        IconHome, IconUserSetting, IconUser, IconVideo, IconBookStroked,
        IconCreditCard, IconUserGroup, IconList, IconAscend, IconCode,
        IconSafe, IconImage, IconArticle, IconPhoneStroke, IconPriceTag,
        IconShoppingBag, IconCart, IconMapPin, IconIdCard, IconMember,
        IconServer, IconSetting, IconAppCenter, IconSemiLogo, IconHelpCircle, IconCopyAdd,
    };

    const getIconComponent = (iconName) => {
        // 移除可能的'<'和'/>'字符
        const cleanIconName = iconName?.replace(/[</>]/g, '');
        return iconMap[cleanIconName] ? React.createElement(iconMap[cleanIconName]) : <IconHome />;
    };

    const fetchMenuData = async () => {
        try {
            const response = await request.get('/go/spc/menus/');
            if (response.errno === 0 && response.list && response.list.length > 0) {
                // 转换菜单数据格式
                const transformedMenuData = response.list.map(item => ({
                    key: item.name,
                    text: item.name,
                    icon: item.fe_icon ? getIconComponent(item.fe_icon) : <IconHome />,
                    children: item.children ? item.children.map(child => ({
                        key: child.fe_url,
                        text: child.name,
                        icon: child.fe_icon ? getIconComponent(child.fe_icon) : <IconHome />
                    })) : []
                }));
                setMenuData(transformedMenuData);

                // 获取当前URL路径
                const pathname = window.location.pathname;
                const currentPage = pathname.split('/').pop() || 'Dashboard';

                // 在转换后的菜单数据中查找当前页面所属的一级菜单
                let foundFirstNav = null;
                let foundSelectedKey = null;

                for (const menu of transformedMenuData) {
                    const matchingChild = menu.children?.find(child => child.key.toLowerCase() === currentPage.toLowerCase());
                    if (matchingChild) {
                        foundFirstNav = menu.key;
                        foundSelectedKey = matchingChild.key;
                        break;
                    }
                }

                // 如果找到匹配的菜单项，更新状态
                if (foundFirstNav) {
                    setCurrentFirstNav(foundFirstNav);
                    setCurrentSelectedKey(foundSelectedKey);
                }
            } else {
                // 使用默认菜单数据
                setMenuData(defaultMenuData);
            }
        } catch (error) {
            console.error('获取菜单数据失败:', error);
            // 使用默认菜单数据
            setMenuData(defaultMenuData);
        }
    };

    useEffect(() => {
        fetchMenuData();
    }, []);

    const getSecondaryNavItems = (firstNavKey) => {
        const menu = menuData.find(item => item.key === firstNavKey);
        return menu?.children || [];
    };
    const getInitialNavText = (key) => {
        return key;
    };
    React.useEffect(() => {
        setCurrentFirstNavText(getInitialNavText(currentFirstNav));
    }, [currentFirstNav]);
    React.useEffect(() => {
        localStorage.setItem('navCollapsed', JSON.stringify(isCollapsed));
    }, [isCollapsed]);
    React.useEffect(() => {
        localStorage.setItem('secondaryNavCollapsed', JSON.stringify(isSecondaryNavCollapsed));
    }, [isSecondaryNavCollapsed]);

    const handleFirstNavSelect = React.useCallback((data, e) => {
        console.log('handleFirstNavSelect', data, e);
        if (!e) {
            e = data.domEvent;
        }
        // 检查是否按下Ctrl键或使用中键点击
        const isCtrlClick = e?.ctrlKey || e?.metaKey;
        const isMiddleClick = e?.button === 1;

        if (isCtrlClick || isMiddleClick) {
            // 阻止默认事件
            e?.preventDefault();
            e?.stopPropagation();
            // 在新标签页打开
            const selectedItem = menuData.find(menu => menu.key === data.itemKey);
            if (selectedItem?.children?.[0]) {
                const newWindow = window.open(`/${selectedItem.children[0].key}`, '_blank');
                if (newWindow) newWindow.focus();
                return;
            }
        }

        const updates = {
            firstNav: data.itemKey,
            secondaryNav: isSecondaryNavCollapsed ? false : undefined
        };
        setCurrentFirstNav(updates.firstNav);
        setCurrentFirstNavText(getInitialNavText(updates.firstNav));
        if (updates.secondaryNav !== undefined) {
            setIsSecondaryNavCollapsed(updates.secondaryNav);
        }

        // 获取当前URL路径并设置对应的二级菜单选中状态
        const pathname = window.location.pathname;
        const currentPage = pathname.split('/').pop() || 'Dashboard';
        const currentMenu = menuData.find(menu => menu.key === data.itemKey);
        if (currentMenu?.children?.some(child => child.key === currentPage)) {
            setCurrentSelectedKey(currentPage);
        }
    }, [isSecondaryNavCollapsed, menuData, onSelect]);
    return (
        <div className={styles.frame}>
            <Nav
                bodyStyle={{ height: 978 }}
                mode="vertical"
                header={{
                    style: { paddingTop: '6px', paddingLeft: '0' },
                    logo: (
                        <div className={styles.navigationHeaderLogo}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={siteConfig.site.logo} alt={siteConfig.site.shortName} className={styles.logoImage} />
                                <div className={styles.logoText}>{siteConfig.site.shortName}</div>
                            </div>
                            {userInfo && (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Dropdown
                                        trigger="click"
                                        position="bottomLeft"
                                        render={
                                            <Dropdown.Menu>
                                                <Dropdown.Item
                                                    onClick={() => onSelect({ itemKey: 'Profile' })}
                                                >
                                                    账号信息
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    onClick={() => {
                                                        Modal.confirm({
                                                            title: '确认退出',
                                                            content: '确认要退出登录吗？',
                                                            okText: '确认',
                                                            cancelText: '取消',
                                                            onOk: async () => {
                                                                try {
                                                                    await request.post('/go/common/logout/');
                                                                    localStorage.removeItem('isLoggedIn');
                                                                    localStorage.removeItem('user');
                                                                    localStorage.removeItem('token');
                                                                    localStorage.removeItem('userInfo');
                                                                    Toast.success('已退出登录');
                                                                    window.location.reload();
                                                                } catch (error) {
                                                                    console.error('退出登录失败:', error);
                                                                    Toast.error('退出登录失败，请重试');
                                                                }
                                                            }
                                                        });
                                                    }}
                                                >
                                                    退出登录
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        }
                                    >
                                        <div className={styles.userInfo}>
                                            <Avatar size="small" color="blue">{userInfo.name?.[0] || userInfo.account?.[0]}</Avatar>
                                            <span className={styles.userName}>{userInfo.name || userInfo.account}</span>
                                        </div>
                                    </Dropdown>
                                </div>
                            )}
                        </div>
                    ),
                }}
                className={`${styles.navVerticalCollapse} ${isCollapsed ? styles.collapsed : ''}`}
                onSelect={handleFirstNavSelect}
                style={{ textAlign: 'center' }}
                selectedKeys={[currentFirstNav]}
                footer={{
                    collapseButton: true,
                    collapseText: () => "",
                    collapseIcon: isCollapsed ? <IconChevronRight /> : <IconChevronLeft />
                }}
                onCollapseChange={setIsCollapsed}
                collapsed={isCollapsed}
            >
                {menuData.map(item => (
                    <Nav.Item
                        key={item.key}
                        itemKey={item.key}
                        text={item.text}
                        icon={item.icon}
                        className={styles.navItem}
                        style={{ width: '100%' }}
                    />
                ))}
            </Nav>
            <div className={styles.main}>
                <div className={`${styles.secondaryNavContainer} ${isSecondaryNavCollapsed ? styles.collapsed : ''}`}>
                    <div className={styles.secondaryNavHeader}>
                        <h3>{currentFirstNavText}</h3>
                        <div className={styles.collapseButton} onClick={() => setIsSecondaryNavCollapsed(prev => !prev)}>
                            {isSecondaryNavCollapsed ? <IconChevronRight /> : <IconChevronLeft />}
                        </div>
                    </div>
                    <Nav
                        className={styles.nav}
                        onSelect={(data, e) => {
                            if (!e) {
                                e = data.domEvent;
                            }
                            // 检查是否按下Ctrl键或使用中键点击
                            const isCtrlClick = e?.ctrlKey || e?.metaKey;
                            const isMiddleClick = e?.button === 1;

                            if (isCtrlClick || isMiddleClick) {
                                // 阻止默认事件
                                e?.preventDefault();
                                e?.stopPropagation();
                                // 在新标签页打开
                                const newWindow = window.open(`/${data.itemKey}`, '_blank');
                                if (newWindow) newWindow.focus();
                                return;
                            }

                            setCurrentSelectedKey(data.itemKey);
                            onSelect(data);
                        }}
                        selectedKeys={[currentSelectedKey]}
                    >
                        {getSecondaryNavItems(currentFirstNav).map(item => (
                            <Nav.Item
                                key={item.key}
                                itemKey={item.key}
                                text={item.text}
                                icon={item.icon}
                                className={styles.navItem2}
                            />
                        ))}
                    </Nav>
                </div>
                <div className={styles.content}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default MainLayout;